import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../../SectionHeading';

const worlds = [
  { name: "Mercur", desc: "Furnalul energetic al civilizației — infrastructură solară care alimentează o întreagă economie interplanetară.", color: "border-orange-500/50 bg-orange-900/10" },
  { name: "Venus", desc: "Terraformat cu răbdare de-a lungul a două secole într-o lume cu cer ambrat, oceane calde și plaje de nisip negru.", color: "border-amber-500/50 bg-amber-900/10" },
  { name: "Marte", desc: "A doua casă a umanității — deșerturi roșii cedând locul orașelor sub cupole și, în cele din urmă, cerului deschis.", color: "border-red-500/50 bg-red-900/10" },
  { name: "Centura", desc: "\"Mia de Lumi\" — Centureni feroce independenți, uniți prin ospitalitate radicală și metafore orbitale.", color: "border-gray-500/50 bg-gray-900/10" },
  { name: "Sistemul Jupiter", desc: "Europa, Ganymede și Callisto — luni de gheață care au alimentat Venus și au ridicat întrebări despre viața de sub suprafețele lor.", color: "border-yellow-500/50 bg-yellow-900/10" },
  { name: "Triton / Neptun", desc: "Ultimul port al umanității — o comunitate de santinele răbdătoare care supraveghează granița dintre sistemul solar și vidul interstelar.", color: "border-blue-500/50 bg-blue-900/10" },
];

const SolarRebornRo = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5">
    <div className="max-w-6xl mx-auto px-6 lg:px-8">
      <SectionHeading title="Un Sistem Solar Renăscut" subtitle="Actul II" />
      <p className="text-gray-400 text-center max-w-3xl mx-auto mb-12 text-lg leading-relaxed">
        Ceea ce urmează nu este nimic mai puțin decât transformarea completă a sistemului solar de-a lungul a patru secole și jumătate. Fiecare capitol se citește ca propria sa lume în interiorul lumii.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {worlds.map((world, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            className={`border rounded-2xl p-6 ${world.color} hover:scale-[1.02] transition-transform duration-300`}
          >
            <h3 className="text-white font-display font-bold text-xl mb-3">{world.name}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">{world.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default SolarRebornRo;